import systemNotificationService from '@/core/services/systemNotification.service';
import { Module } from 'vuex';

const maintenanceStore: Module<any, any> = {
   namespaced: true,

   state: {
      system_notification: null,
   },

   getters: {
      showBanner: (state) => {
         if (state.system_notification === null) return false;

         const NOW = new Date();
         const START = new Date(state.system_notification?.publish_at);
         const END = new Date(state.system_notification?.unpublish_at);
         return START <= NOW && NOW < END;
      },
   },

   mutations: {
      SET_SYSTEM_NOTIFICATION(state: any, system_notification: any) {
         state.system_notification = system_notification;
      },
   },

   actions: {
      async getSystemNotification({ commit }: any) {
         const SYSTEM_NOTIFICATION = await systemNotificationService.get();
         commit('SET_SYSTEM_NOTIFICATION', SYSTEM_NOTIFICATION);
      },
   },
};

export default maintenanceStore;
